import React from 'react';
import './CostOverview.scss';
import {CalculatedOption} from "../../config/interfaces";
import {toMoneyNotation} from "../../config/functions";

interface CostOverviewProps {
    options: CalculatedOption[];
    onClick: (event: React.MouseEvent) => void;
}

/**
 * Component which shows the current best calculated result at the bottom of the page
 * @param {CostOverviewProps} props - The props that the CostOverview component accepts.
 * @param {CalculatedOption[]} props.options - Array of calculated options, every brand that is selected has one option in this array.
 * @param {Function} props.onClick - Function after click (opening dialog)
 * @constructor
 */
export default function CostOverview(props: CostOverviewProps) {
    const {options, onClick} = props;
    const option = options.sort((a, b) => a.totalPriceIncl! - b.totalPriceIncl!)[0];
    if (!option || !option.totalPriceExcl) {
        return <div />;
    }

    return <div id="cost-overview" className={'overviewButton'} onClick={onClick}>
        <div>
            <div className={'title'}>
                <div id={'title-logo'}>
                    <img src={`/images/logo-${option.brand.toLowerCase()}.png`} alt={''} style={{height: 60}} />
                </div>
                <div id={'title-costs'}>
                    <h3 style={{fontWeight: 'bold'}}>{toMoneyNotation(option.totalPriceIncl!)}</h3>
                    <span className={'very-small'}>incl. btw</span>
                </div>
            </div>
        </div>
        <div className={'leverinfo'}>
             Levering binnen 4-7 weken
        </div>
        <div className={'overview'}>
            <br />
        </div>
    </div>;
}